module.exports = __webpack_public_path__ + "/da3450c54d29a9d403c29c1b71dafc64.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/teams_icon.svg
 ** module id = 1115
 ** module chunks = 0
 **/